import { useAuth } from "@/lib/auth";
import Landing from "./Landing";
import Dashboard from "./Dashboard";

export default function Home() {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen bg-background" aria-busy="true" />;
  }
  return user ? <Dashboard /> : <Landing />;
}
